import { ContentType } from "./mods";

// Grid related types
export interface CellState {
    occupied: boolean;
    disabled: boolean;
  }
  
  export type GridState = CellState[][];
  
  export interface Position {
    row: number;
    col: number;
  }
  
  // Idol related types
  export interface ItemSize {
    width: number;
    height: number;
    color: string;
    name: string;
  }
  
  export interface ItemType {
    MINOR: ItemSize;
    TOTEMIC: ItemSize;
    CONQUEROR: ItemSize;
    KAMASAN: ItemSize;
    NOBLE: ItemSize;
    BURIAL: ItemSize;
    UNIQUE: ItemSize;
    [key: string]: ItemSize;
  }
  
  export interface StatRange {
    text: string;
    range: [number, number];
  }
  
  export interface IdolStatCategory {
    prefixes: StatRange[];
    suffixes: StatRange[];
  }
  
  export interface IdolStats {
    MINOR: IdolStatCategory;
    NOBLE: IdolStatCategory;
    [key: string]: IdolStatCategory;
  }
  
  export interface StatType {
    id: number;
    name: string;
  }
  
  export interface Idol {
    id: string;
    size: ItemSize;
    name?: string;
    position?: Position;
    stats: Stat[];
    stashTabName?: string;  // New field
    stashPosition?: {       // New field
      x: number;
      y: number;
    };
  }
  
  // Form related types
  export interface Modifier {
    text: string;
    value: string;
  }
  
  // State related types
  export interface AppState {
    grid: GridState;
    placedItems: Idol[];
    stashItems: Idol[];
    draggedItem: Idol | null;
    tooltipItem: Idol | null;
    mousePosition: { x: number; y: number };
    hoverPosition: Position | null;
    stats: Record<string, number>; 
  }
  
  // Storage related types
  export interface StorageItems {
    placedItems: Idol[];
    stashItems: Idol[];
  }

// Update this in your types.ts file or wherever the Stat interface is defined
export interface Stat {
  modId: number;
  value: number;
  explicitType: string;  
  contentType?: ContentType;
  tradeId?: string;
}

export interface ExtendedStat extends Stat {
  text: string;
}

export interface StashTab {
  id: string;
  parent?: string;
  name: string;
  type: string;
  index?: number;
  metadata: {
    public?: boolean;
    folder?: boolean;
    colour?: string;
  };
  children?: StashTab[];
  items?: Item[];
}

export type Item = {
  id?: string;
  name: string;
  typeLine: string;
  baseType?: string;
  rarity?: string;
  icon?: string;
  ilvl?: number;
  itemLevel?: number;
  identified?: boolean;
  corrupted?: boolean;
  properties?: ItemProperty[];
  requirements?: ItemProperty[];
  implicitMods?: string[];
  explicitMods?: string[];
  craftedMods?: string[];
  frameType?: FrameType;
  x?: number; // Position in stash
  y?: number; // Position in stash
  w?: number; // Width
  h?: number; // Height
  sockets?: {
    group: number;
    attr?: string;
    sColour?: string;
  }[];
};

export type ItemProperty = {
  name: string;
  values: [string, number][]; // [value, displayType]
  displayMode?: number;
};

export enum FrameType {
  Normal = 0,
  Magic = 1,
  Rare = 2,
  Unique = 3,
  Gem = 4,
  Currency = 5,
  DivinationCard = 6,
  Quest = 7,
  Prophecy = 8,
  Foil = 9
}

export type TokenResponse = {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  username?: string;
  refresh_token?: string;
};

export type ErrorResponse = {
  error: string;
  details?: unknown;
  message?: string;
  retryAfter?: number;
};

// Configuration for Path of Exile OAuth
export const POE_AUTH_CONFIG = {
  clientId: 'poeidolplanner', // Your registered client ID
  redirectUri: 'https://poe-idol-planner-production.up.railway.app/auth/callback', 
  scope: 'account:stashes', 
  authorizationBaseUrl: 'https://www.pathofexile.com/oauth/authorize',
  tokenProxyUrl: '/api/oauth/token', // Server-side proxy endpoint
  stashApiUrl: '/api/stash' // Server-side proxy for stash API
};

// Rate limiting configuration
export const RATE_LIMIT = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 25000, // 5 seconds initial delay
  MAX_RETRY_DELAY: 60000, // 60 seconds max delay
  retryCount: 0
};